import React from "react";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { DateRangePicker } from "react-date-range";
import * as rdrLocales from 'react-date-range/dist/locale';
import { defaultInputRanges, defaultStaticRanges } from "../../../services/defaultRanges";
import { useStyles } from "../../../assets/jss/CustomDateRange";
import { useTranslation } from "react-i18next";

const CustomDateRange = (props: any) => {
  const classes = useStyles();
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = React.useState('')
  React.useEffect(() => {
    if (i18n.language) {
      const _lang = i18n.language.split("-")
      setCurrentLang(_lang[0])
    }
  }, [i18n.language])
  return (
    <DateRangePicker
      locale={rdrLocales[currentLang]}
      {...props}
      scroll={{ enabled: true }}
      staticRanges={defaultStaticRanges(t("TODAY"), t("YESTERDAY"), t("LAST_WEEK"), t("LAST_THREE_WEEKS_RESET"), t("LAST_MONTH"))}
      inputRanges={defaultInputRanges(t("DAYS_UP_TO_TODAY"))}
      className={classes.dateRangePickerWrapper}
    />
  );
};

export default CustomDateRange;
